import type { JSX } from 'react';
import { Link } from 'react-router';
import { ConsentCheckbox } from '../components/ConsentCheckbox.js';
import { useLegal } from '../brand/legal-context.js';
import { useI18n } from '../i18n/context.js';

/**
 * Clickwrap at payment (docs/north-america-launch-requirements.md §2.5, §6.4): an
 * unchecked box next to the button, links that stand out from the text around them.
 * The caller keeps its Pay button disabled until `checked`, and that is the only gate:
 * the server opens no payment without `acceptedTerms` anyway, for the book and the
 * replacement pack alike.
 */
export function PaymentTerms({
  checked,
  disabled,
  onChange,
}: {
  readonly checked: boolean;
  readonly disabled: boolean;
  onChange(checked: boolean): void;
}): JSX.Element {
  const { t } = useI18n();
  const legal = useLegal();
  const link = 'font-medium text-[var(--kitup-color-primary)] underline';
  return (
    <ConsentCheckbox
      checked={checked}
      disabled={disabled}
      onChange={(event) => onChange(event.target.checked)}
      label={
        <>
          {t.monetization.payment.legalPrefix}{' '}
          <Link className={link} to={legal.routes.terms} target="_blank">
            {t.monetization.payment.offerLink}
          </Link>{' '}
          {t.monetization.payment.legalJoin}{' '}
          <Link className={link} to={legal.routes.payment} target="_blank">
            {t.monetization.payment.refundLink}
          </Link>
          .
        </>
      }
    />
  );
}
